import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { exportPDF, Group } from '@progress/kendo-drawing';
import { ToastrService } from 'ngx-toastr';
import { CommonApiService } from 'src/app/commonapiservice';
import { GlobalComponent } from 'src/app/global/global.component';

@Component({
  selector: 'app-uac-coversheet',
  templateUrl: './uac-coversheet.component.html',
  styleUrls: ['./uac-coversheet.component.scss']
})
export class UacCoversheetComponent implements OnInit {
  @ViewChild("pdfUAC_Letter") pdfUAC_Letter;
  isDownloadPDF:boolean=false;
  UACFaxList:any;
  faxName:string;
  PropertyandCasualtyClaim :any;
  ContactNamePhone:any;
  Disclaimer:any;
  otherFax:any;
  constructor(public global:GlobalComponent,private datePipe: DatePipe,public toastrService : ToastrService,public CommonAPI: CommonApiService) { }

  ngOnInit(): void {
    this.global.coverLetterDetails.attachmentControlNumber = "PWK" + (this.global.coverLetterDetails.attachmentControlNumber || '')
    this.global.coverLetterDetails.attachmentSendDate = (this.global.coverLetterDetails.attachmentSendDate != null && this.global.coverLetterDetails.attachmentSendDate != undefined && this.global.coverLetterDetails.attachmentSendDate != "") ?
      this.datePipe.transform(this.global.coverLetterDetails.attachmentSendDate, "MM/dd/yyyy") : null;
    this.getFaxList();
  }
  PDFDownload(){
    this.DownloadUACLetter();
  }
  DownloadUACLetter() {    
    (this.pdfUAC_Letter.A4 = true),
      (this.pdfUAC_Letter.portrait = true),
      (this.pdfUAC_Letter.keepTogether = ".prevent-split"),
      (this.pdfUAC_Letter.scale = 0.8),
      (this.pdfUAC_Letter.height = 100),
      this.pdfUAC_Letter.padding = { bottom: "40px" };
    this.pdfUAC_Letter.forcePageBreak = ".page-header";
    this.pdfUAC_Letter.saveAs(
      "UAC Letter" +
      new Date().toLocaleDateString() +
      "-" +
      new Date().toLocaleTimeString()
    );
    this.isDownloadPDF = false;
  }

  //......................................Get ReportTypeDeopdownList.....................................
  getFaxList() {
    let url = "api/LOV/LovDropDownWithValue?"
    let params = new URLSearchParams();
    params.append("Code", "UACFAX");
    this.CommonAPI.getDropDownList("UACFAX", params, url, "LovDropDown").then(
      (data: any) => {
        data.forEach((ele)=>{
          ele.lovCode = ele.lovCode + ' (' + ele.value + ')';
        })
        data.push({ key: 0, lovCode: "" ,value:""})
        this.UACFaxList = this.sortingList(data) ;       
      },
      (err: any) => {
        this.toastrService.error(err);
      }
    );
  }
  sortingList(datalist: any) {
    return datalist.slice().sort((a, b) => a.lovCode.localeCompare(b.lovCode));
  }

  PrintLetter(): void {
      (this.pdfUAC_Letter.A4 = true),
        (this.pdfUAC_Letter.portrait = true),
        (this.pdfUAC_Letter.keepTogether = ".prevent-split"),
        (this.pdfUAC_Letter.scale = 0.6),
        (this.pdfUAC_Letter.height = 100),
        (this.pdfUAC_Letter.margin = {
          left: "1cm",
          top: "1cm",
          right: "0.2cm",
          bottom: "1cm",
        });
      this.pdfUAC_Letter.padding = { bottom: "50px" };
      this.pdfUAC_Letter.forcePageBreak = ".page-header";
      this.pdfUAC_Letter
        .export()
        .then((completedata: Group) => exportPDF(completedata))
        .then(async (base64) => {
          const fileObject = this.dataURLtoFile(base64, "test");
          var fileurl = URL.createObjectURL(fileObject);
          var Output = window.open(fileurl, "", "height=500, width=500");
          Output.print();
        });
    }

  // .....................................................dataURLtoFile...........................................
  public dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }
  
}
